<template>
    <a
        @click.prevent="onClickHandler"
        :style="`max-width: ${logoSize}rem; background-color: ${shadow};`"
        href="#"
        aria-label="Link to Home Page"
        id="logo-img"
        class="mask w-auto h-auto logo-link inline-flex animated fadeIn cursor-pointer"
    >
        <div class="mask" :style="`background-color: ${color};`">
            <img class="w-full" src="../assets/logo.png" alt="Topbar TheBigQuiz Logo" />
        </div>
    </a>
</template>

<script>
import popup from '@/lib/popup.js'
import UserService from '@/lib/user.js'
import { nuxtUrl } from '@/lib/nuxt-url.js'

export default {
    props: {
        logoWidth: {
            default: 13
        },

        warningMessage: {
            default: ''
        },

        mobileLogoWidth: {
            default: 13
        },

        embed: {
            type: String,
            default: null
        },

        url: {
            type: String,
            default: null
        },

        color: {
            type: String,
            default: '#fff'
        },

        shadow: {
            type: String,
            default: '#000'
        }
    },

    name: 'HeaderLogo',

    data() {
        return {
            logoSize: this.logoWidth
        }
    },

    mounted() {
        this.checkingScreen()
        window.addEventListener('resize', this.checkingScreen, false)
    },

    methods: {
        onClickHandler() {
            window.onbeforeunload = function () {}

            const userService = new UserService()

            if (this.embed) {
                window.open('/', '_blank')
                return
            }

            if (this.isSkolerPage() || userService.getUser().provider === 'feide') {
                window.location.href = nuxtUrl('/skoler')
                return
            }

            if (
                this.isSchoolPage() ||
                ['teacher', 'teacher_plus', 'student', 'student_plus'].includes(userService.getUser().role)
            ) {
                window.location.href = nuxtUrl('/school')
                return
            }

            if (['play-alone-summary'].indexOf(this.$route.name) > -1) {
                window.location.href = nuxtUrl('/')
                return
            }

            if (this.warningMessage.length > 0) {
                popup.confirm(
                    this.warningMessage,
                    function () {
                        window.location.href = nuxtUrl('/')
                    },
                    function () {
                        window.onbeforeunload = function () {
                            return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                        }
                    }
                )
            } else {
                window.location.href = nuxtUrl('/')
            }
        },

        checkingScreen() {
            if (window.innerWidth <= 767) {
                this.logoSize = this.mobileLogoWidth === 13 ? this.logoSize : this.mobileLogoWidth
            } else {
                this.logoSize = this.logoWidth
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('componentAlready'))
                }, 200)
            })
        }
    }
}
</script>

<style lang="scss">
#logo-img {
    // object-fit: contain;

    img {
        visibility: hidden;
        object-fit: contain;
    }
}

.mask {
    -webkit-mask-image: url(../assets/logo.png);
    -webkit-mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    mask-image: url(../assets/logo.png);
    mask-size: contain;
    mask-repeat: no-repeat;
}
</style>
